import React, { FunctionComponent, useEffect } from 'react'

import { LanguageList } from '@/models/common'
import i18n from '@/translations'

import { DropDownSelect, Option } from './dropdown-select'

interface Props {
  isPublic?: boolean
}

export const LanguageSelector: FunctionComponent<Props> = ({ isPublic }) => {
  const options = Object.keys(LanguageList).map(key => ({
    label: LanguageList[key as keyof typeof LanguageList],
    name: LanguageList[key as keyof typeof LanguageList],
  }))
  const defaultOption = options.find(option => option.name === i18n.language) ?? { name: 'en', label: 'en' }

  useEffect(() => {
    if (defaultOption.name !== i18n.language) {
      i18n.changeLanguage('en')
    }
  }, [defaultOption, i18n])
  const changeLanguage = (option: Option) => {
    const nextLang = option.name
    i18n.changeLanguage(nextLang)
  }

  return <DropDownSelect isPublic={isPublic} options={options} onChange={changeLanguage} selectedOption={defaultOption} />
}
